import React from 'react'

import {
    MDBCarousel,
    MDBCarouselCaption,
    MDBCarouselInner,
    MDBCarouselItem,
    MDBMask,
    MDBView
} from "mdbreact";
import Botones from './Botones';
import { useValidarImagen, useValidarImagenCarousel } from '../../../hooks/useValidarImagen';
const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES

export const Carousel = (props) => {
    const {
        urlImg,
        urlImg2,
        urlImg3
    } = props?.styles;

    let stylesOptions = {
        showControls: false,
        showIndicators: false,
        slide: false,
        black: false,
        text: false,
        interval: false,
    }

    if (props.styles.style1) {
        stylesOptions = {
            ...stylesOptions,
            text: true,
            black: true
        }
    } else if (props.styles.style2) {
        stylesOptions = {
            ...stylesOptions,
            showControls: true,
            showIndicators: true
        }
    } else if (props.styles.style3) {
        stylesOptions = {
            ...stylesOptions,
            showControls: true,
            showIndicators: true,
            slide: true,
            black: true,
            interval: true,
        }
    }

    return (
        <MDBCarousel
            activeItem={1}
            length={3}
            showControls={stylesOptions.showControls}
            showIndicators={stylesOptions.showIndicators}
            slide={stylesOptions.slide}
            className="z-depth-1 carousel-componentes"
            interval={stylesOptions.interval ? 4000 : false}
        >
            <MDBCarouselInner>
                <MDBCarouselItem itemId="1">
                    <MDBView>
                        <img
                            className="d-block w-100"
                            src={useValidarImagenCarousel(urlImg)}
                        />
                        {stylesOptions.black && <MDBMask overlay="black-light" />}
                    </MDBView>
                    {stylesOptions.text && <div className='carousel-opciones'>
                        <h3 className="h3-responsive">{props.styles.titulo ? props.styles.titulo : 'Strong mask'}</h3>
                        <p>{props.styles.subTitulo ? props.styles.subTitulo : 'Second text'}</p>
                        <Botones {...props} />
                    </div>}
                </MDBCarouselItem>
                <MDBCarouselItem itemId="2">
                    <MDBView>
                        <img
                            className="d-block w-100"
                            src={useValidarImagenCarousel(urlImg2)}
                        />
                        {stylesOptions.black && <MDBMask overlay="black-light" />}
                    </MDBView>
                    {stylesOptions.text && <MDBCarouselCaption>
                        <h3 className="h3-responsive">{props.styles.titulo ? props.styles.titulo : 'Strong mask'}</h3>
                        <p>{props.styles.subTitulo ? props.styles.subTitulo : 'Second text'}</p>
                    </MDBCarouselCaption>}
                </MDBCarouselItem>
                <MDBCarouselItem itemId="3">
                    <MDBView>
                        <img
                            className="d-block w-100"
                            src={useValidarImagenCarousel(urlImg3)}
                        />
                        {stylesOptions.black && <MDBMask overlay="black-light" />}
                    </MDBView>
                    {stylesOptions.text && <MDBCarouselCaption>
                        <h3 className="h3-responsive">{props.styles.titulo ? props.styles.titulo : 'Strong mask'}</h3>
                        <p>{props.styles.subTitulo ? props.styles.subTitulo : 'Second text'}</p>
                    </MDBCarouselCaption>}
                </MDBCarouselItem>
            </MDBCarouselInner>
        </MDBCarousel>
    )
}
